import { render, staticRenderFns } from "./ScrollGradient.vue?vue&type=template&id=36fdbd22&lang=pug&"
import script from "./ScrollGradient.vue?vue&type=script&lang=js&"
export * from "./ScrollGradient.vue?vue&type=script&lang=js&"
import style0 from "./ScrollGradient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36fdbd22')) {
      api.createRecord('36fdbd22', component.options)
    } else {
      api.reload('36fdbd22', component.options)
    }
    module.hot.accept("./ScrollGradient.vue?vue&type=template&id=36fdbd22&lang=pug&", function () {
      api.rerender('36fdbd22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/ScrollGradient.vue"
export default component.exports